<script>

///Ultima alteração: 27/05/2020
///Alterado por: Allinne

    import CaracteristicaItem       from './BarraCaracteristicas__Item.svelte';

    export let realty = null;
    export let style  = "";
</script>

<div class="caracteristicas">
    <slot>
        <CaracteristicaItem style={style} realty={realty} type="Id"/>
        <CaracteristicaItem style={style} realty={realty} type="Bathrooms" />
        <CaracteristicaItem style={style} realty={realty} type="Bedrooms" />
        <CaracteristicaItem style={style} realty={realty} type="ParkingSpots" />
        <CaracteristicaItem style={style} realty={realty} type="Furnished" />
        <CaracteristicaItem style={style} realty={realty} type="Area" />
        <CaracteristicaItem style={style} realty={realty} type="LotArea" />
    </slot>
</div> 

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.caracteristicas
	display: flex
	align-items: center
	justify-content: center
	flex-wrap: wrap
	text-align: center
	font-size: inherit
</style>